import React from "react"
import classes from "./ProductCheckboxFilterItem.module.css"
import classnames from "classnames"
import { CategoriesTreeItem } from "../../controller/state/categories"
import CheckboxFilterItem from "../CheckboxFilterItem"

interface Props {
  options: CategoriesTreeItem[]
  firstLevel: boolean
  onClick: (option: CategoriesTreeItem) => void
  onExpand: (option: CategoriesTreeItem) => void
  expandedMap: any
  expanded?: boolean
}

const ProductCheckboxFilterItem = ({
  options,
  onClick,
  firstLevel,
  expandedMap,
  onExpand,
  expanded,
}: Props) => {
  const isDisabled = (option: CategoriesTreeItem) => option.count === 0
  const isExpanded = (option: CategoriesTreeItem) =>
    !isDisabled(option) && expandedMap[option.code]

  return (
    <ul
      className={classnames(
        "w-full",
        !firstLevel && "pl-9 sm:pl-4 mb-2",
        !expanded && "hidden"
      )}
    >
      {options
        .filter((x) => x.enabled)
        .map((option) => {
          if (option.children && option.children.length > 0) {
            return (
              <li key={option.code} className="flex flex-wrap items-center">
                <div
                  className={classnames(
                    "cursor-pointer mr-2 text-xs",
                    classes.caret,
                    isExpanded(option) && classes["caret-down"]
                  )}
                  onClick={() => onExpand(option)}
                >
                  &#9654;
                </div>
                <div
                  className={`${classes.labelButton} ${
                    isDisabled(option) ? "opacity-50" : "cursor-pointer"
                  }`}
                  onClick={() => {
                    if (!isDisabled(option)) {
                      onClick(option)
                    }
                  }}
                >
                  {option.label} ({option.count})
                </div>
                <ProductCheckboxFilterItem
                  expandedMap={expandedMap}
                  onExpand={onExpand}
                  options={option.children}
                  firstLevel={false}
                  expanded={isExpanded(option)}
                  onClick={onClick}
                />
              </li>
            )
          }
          return (
            <li key={option.code} className="flex items-center">
              <CheckboxFilterItem
                label={option.label}
                count={option.count}
                selected={option.checked}
                onClick={() => onClick(option)}
              />
            </li>
          )
        })}
    </ul>
  )
}

export default ProductCheckboxFilterItem
